<template>
    <ConfigSection :title="$t('phu_production.configuration.products')">
        <div class="products-config__search">
            <SearchBar :search="search" :placeholder="$t('phu_production.configuration.search')" @on-search="onSearch" @on-button-click="search = ''" />
        </div>
        <div class="products-config__grid">
            <ProductConfigCard
                v-for="product in filteredProducts"
                :key="product.id"
                :product="product"
                @toggle="$emit('toggle', product.id)"
                @container="$emit('container', { productId: product.id, field: $event.field, value: $event.value })"
            />
        </div>
    </ConfigSection>
</template>

<script>
import ConfigSection from './ConfigSection.vue'
import ProductConfigCard from './ProductConfigCard.vue'
import SearchBar from '@/components/domain/ui/SearchBar.vue'

export default {
    name: 'ProductsSection',
    components: { ConfigSection, ProductConfigCard, SearchBar },
    props: {
        products: { type: Array, required: true }
    },
    data() {
        return {
            search: ''
        }
    },
    computed: {
        filteredProducts() {
            const term = this.search.trim().toLowerCase()
            const products = [...this.products].sort((a, b) => a.name.localeCompare(b.name))
            if (!term) {
                return products
            }
            return products.filter((product) => product.name.toLowerCase().indexOf(term) !== -1)
        }
    },
    methods: {
        onSearch(event) {
            this.search = event.target.value
        }
    }
}
</script>

<style lang="scss" scoped>
.products-config__search {
    align-self: flex-end;
    width: 50%;
}

.products-config__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 8px;
}
</style>
